export var HIDE_TIME = 200;
